/*
    Блокировка скролла
*/

class LockScroll {
    constructor() {
        this.ios = App.H.is('.ios');
        this.scroll = 0;
    }

    lock() {
        this.scroll = App.W.scrollTop();

        App.B.addClass('_noscroll');
        $('html, body').scrollTop(this.scroll);
    }

    unlock() {
        App.B.removeClass('_noscroll');
        $('html, body').scrollTop(this.scroll);
    }
}

App.lockScroll = new LockScroll();



// WEBPACK FOOTER //
// ./_src/js/modules/LockScroll.js